// extracted by mini-css-extract-plugin
export default {"wrapper":"LiveNow_wrapper__nOdvN","title":"LiveNow_title__+abtk"};